"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var utils_1 = require("../utils");
var context_1 = require("../context");
var mobx_1 = require("mobx");
var Control_1 = require("./Control");
var ComputedControl = /** @class */ (function (_super) {
    __extends(ComputedControl, _super);
    function ComputedControl(props) {
        var _this = _super.call(this, props) || this;
        utils_1.verifyRequiredProps(ComputedControl_1.requiredProps, _this.props, _this);
        return _this;
    }
    ComputedControl_1 = ComputedControl;
    ComputedControl.prototype.componentDidMount = function () {
        var _this = this;
        var componentOwnProps = utils_1.omit(this.props, ['form']);
        this.formValueUpdateUnsubscribe = mobx_1.reaction(function () { return _this.props.compute(_this.props.form.values, componentOwnProps); }, function (newValue) { _this.field.onChange(newValue); }, { fireImmediately: true });
    };
    ComputedControl.prototype.componentWillUnmount = function () {
        this.formValueUpdateUnsubscribe();
    };
    ComputedControl.prototype.render = function () {
        var _this = this;
        // tslint:disable-next-line:max-line-length
        var controlProps = utils_1.omit(this.props, ComputedControl_1.skipProp);
        return (React.createElement(Control_1.ControlWithContext, __assign({}, controlProps, { fieldRef: function (field) { _this.field = field; } })));
    };
    var ComputedControl_1;
    ComputedControl.requiredProps = ['component', 'name', 'compute'];
    ComputedControl.skipProp = ['compute'];
    ComputedControl = ComputedControl_1 = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ComputedControl);
    return ComputedControl;
}(React.Component));
exports.ComputedControl = ComputedControl;
// tslint:disable-next-line:variable-name
exports.ComputedControlWithContext = context_1.withForm(ComputedControl);
//# sourceMappingURL=ComputedControl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/ui/ComputedControl.js
// module id = 131
// module chunks = 0